module.exports = __webpack_public_path__ + "static/img/95044A_2_3_R_20181128_fit.5df904c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/95044A_2_3_R_20181128_fit.png
// module id = F7Jt
// module chunks = 0